import { Suspense, useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import InfiniteScroll from "react-infinite-scroll-component";
import Layout from "../components/Layout";
import { useFetchArtists } from "../hooks/useFetchArtists";
import CityDropDown from "../components/CityDropDown";
import FilterComp from "../components/FilterComp";
import Hero from "../components/Hero";
import LoadingSpinner from "../components/LoadingSpinner";
import CardLoader from "../components/CardLoader";
import Card from "../components/Card";
import AnimatedSearchBar from "../components/AnimatedSearchBar";
import NoContentAvailable from "../components/NoContentAvailable";
import PageSeoContent from "../components/PageSeoContent";

const Artists = () => {
  const navigate = useNavigate();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const [filterComponent, setFilterComponent] = useState(false);
  const [selectedFilter, setSelectedFilter] = useState({});
  const [searchTerm, setSearchTerm] = useState("");
  const selectedCity = useSelector((state) => state.citySelector.selectedCity);
  const {
    data,
    fetchNextPage,
    hasNextPage,
    isLoading,
    isFetching,
    refetch,
  } = useFetchArtists(selectedFilter, selectedCity);

  const artists =
    data?.pages?.flatMap((page) => page?.data || []).filter(Boolean) || [];
  const showPageLoader = (isLoading || isFetching) && !artists.length;

  const onPressApply = (data) => {
    setFilterComponent(false);
    setSelectedFilter(data);
  };

  const onPressCancel = () => {
    setFilterComponent(false);
  };

  return (
    <Layout>
      <Hero title="Artists" />
      {/* Club Start */}
      <div
        className="hero fillter-sec section-gap wow fadeInUp"
        data-wow-delay="0.2s"
      >
        <div className="container">
          <form
            className="location-sec"
            onSubmit={(event) => {
              event.preventDefault();
              navigate(`/search?q=${encodeURIComponent(searchTerm)}`);
            }}
          >
            <div className="row">
              <div className="col-lg-6 col-xl-8">
                <div className="row">
                  <div className="col-lg-6 mb-md-4 mb-xl-0">
                    <CityDropDown />
                  </div>
                  <div className="col-lg-6">
                    <AnimatedSearchBar
                      onChange={(event) => setSearchTerm(event.target.value)}
                    />
                  </div>
                </div>
              </div>
              <div className="col-lg-6 col-xl-4">
                <div className="row">
                  <div className="col-lg-4">
                    <div
                      className="fillter-button wow fadeInUp"
                      data-wow-delay="0.5s"
                    >
                      <button
                        type="button"
                        className="btn"
                        onClick={() => setFilterComponent(true)}
                      >
                        <i className="fa fa-cog"></i> Filter
                      </button>
                    </div>
                  </div>
                  <div className="col-lg-4">
                    <div
                      className="dj-button wow fadeInUp"
                      data-wow-delay="0.5s"
                    >
                      <button
                        type="button"
                        className="btn"
                        style={{
                          backgroundColor:
                            selectedFilter?.artist?.toLowerCase() === "dj"
                              ? "#000"
                              : "#FFF",
                          color:
                            selectedFilter?.artist?.toLowerCase() === "dj"
                              ? "#FFF"
                              : "#000",
                        }}
                        onClick={() => {
                          if (selectedFilter?.artist?.toLowerCase() !== "dj") {
                            setSelectedFilter({
                              ...selectedFilter,
                              artist: "dj",
                            });
                          } else {
                            setSelectedFilter({
                              ...selectedFilter,
                              artist: "",
                            });
                          }
                        }}
                      >
                        <i className="fa fa-headphones"></i> DJ
                      </button>
                    </div>
                  </div>
                  <div className="col-lg-4">
                    <div
                      className="singer-button wow fadeInUp"
                      data-wow-delay="0.5s"
                    >
                      <button
                        type="button"
                        className="btn"
                        style={{
                          backgroundColor:
                            selectedFilter?.artist?.toLowerCase() === "artist"
                              ? "#000"
                              : "#FFF",
                          color:
                            selectedFilter?.artist?.toLowerCase() === "artist"
                              ? "#FFF"
                              : "#000",
                        }}
                        onClick={() => {
                          if (
                            selectedFilter?.artist?.toLowerCase() !== "artist"
                          ) {
                            setSelectedFilter({
                              ...selectedFilter,
                              artist: "artist",
                            });
                          } else {
                            setSelectedFilter({
                              ...selectedFilter,
                              artist: "",
                            });
                          }
                        }}
                      >
                        <i className="fa fa-music"></i> Singer
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
      {/* Club End */}

      <PageSeoContent variant="artists" />

      {/* Search Result Start */}
      <div
        className="club-result-row section-gap-btm wow fadeInUp"
        data-wow-delay="0.2s"
      >
        <div className="container">
          {showPageLoader ? (
            <LoadingSpinner className="spinner-container--page" />
          ) : (
            <InfiniteScroll
              dataLength={artists?.length}
              next={hasNextPage ? fetchNextPage : refetch}
              hasMore={hasNextPage}
              loader={<LoadingSpinner className="spinner-container--inline" />}
              refreshFunction={refetch}
            >
              {artists?.length > 0 ? (
                <div className="row">
                  {artists.map((artist, index) => (
                    <Suspense fallback={<CardLoader />} key={index.toString()}>
                    <Card artist={artist} index={index} />
                    </Suspense>
                  ))}
                </div>
              ) : (
                <NoContentAvailable
                  title="No Content Available"
                  message="Artist page is empty. No content available yet."
                />
              )}
            </InfiniteScroll>
          )}
        </div>
      </div>
      {/* Search Result End */}

      <FilterComp
        isModalOpen={filterComponent}
        isArtistFilter={true}
        onPressApply={onPressApply}
        onPressCancel={onPressCancel}
        selectedFilter={selectedFilter}
      />

      <Link to="#" className="back-to-top">
        <i className="fa fa-chevron-up"></i>
      </Link>
    </Layout>
  );
};

export default Artists;
